import React, { useState, useEffect } from 'react';
import { scroller } from 'react-scroll';

export default function ScrollDownButton({ position: elementId, dir }) {
  const isBrowser = typeof window !== 'undefined';

  const [isNavOpen, setIsNavOpen] = useState(true);
  const [innerWidth, setInnerWidth] = useState(isBrowser && window.innerWidth);
  const [isInnerPage, setIsInnerPage] = useState(null);
  const eleId = elementId || 'main';
  useEffect(() => {
    (() =>
      document.querySelector(eleId) && document.querySelector(eleId).setAttribute('name', eleId))();
  }, []);

  useEffect(() => {
    if (isBrowser) {
      window.addEventListener('scroll', () => {
        setIsInnerPage(
          document.querySelector('#secondary-navbar') &&
            document.querySelector('#secondary-navbar').classList.contains('fix'),
        );
        setIsNavOpen(
          document.querySelector('#topbar-header') &&
            document.querySelector('#topbar-header').classList.contains('isSticky'),
        );
      });
      window.addEventListener('mousemove', () => {
        setIsInnerPage(
          document.querySelector('#secondary-navbar') &&
            document.querySelector('#secondary-navbar').classList.contains('fix'),
        );
        setIsNavOpen(
          document.querySelector('#topbar-header') &&
            document.querySelector('#topbar-header').classList.contains('isSticky'),
        );
      });
      window.addEventListener('resize', () => setInnerWidth(window.innerWidth));
    }
  });

  const handleElHeight = () => {
    if (isNavOpen) return isInnerPage ? -140 : -180;
    if (isBrowser && window.scrollY === 0) return isInnerPage ? -140 : -180;
    return 0;
  };

  const options = {
    smooth: true,
    delay: 100,
    offset: handleElHeight(),
    isDynamic: true,
    duration: 500,
  };

  const handleClick = () => scroller.scrollTo(elementId, options);

  return (
    innerWidth >= 1200 && (
      <button type="button" onClick={handleClick} className="scr-down bounce" dir={dir}>
        <span />
      </button>
    )
  );
}
